<template>
  <v-card class="pa-0">
    <v-card-text v-if="items.length > 0" class="pa-0" style="height: 130px; overflow: auto;">
      <v-list class="pa-0">
        <template v-for="(item, index) in items">
          <v-subheader v-if="item.header" :key="item.header">{{ item.header }}</v-subheader>
          <v-divider v-else :key="index"></v-divider>
          <v-list-item :key="item.id" @click="handleClick(item)" class="pa-1">
            <v-list-item-avatar :color="item.seen ? 'green' : 'red'" small>
              <span v-if="item.context == 'covidAlert'" small dark>🦠</span>
              <span v-else>
                <v-icon small dark>notifications</v-icon>
              </span>
            </v-list-item-avatar>
            <v-list-item-content style="padding: 3px 0px">
              <h3 style="font-size: 14px !important; margin: 0px;">{{ item.message }}</h3>
              <p style="font-size: 12px; margin: 7px 0px 0px 0px">{{ ago(item.createdOn) }}</p>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-card-text>
    <v-divider></v-divider>
    <div style="text-align: right; padding: 3px">
      <v-btn
        text
        to="/notificationslist"
        style="font-size: 13px; border-radius: 2px; box-shadow: none ; text-transform: none"
      >Show All</v-btn>
    </div>
  </v-card>
</template>

<script>
import moment from "moment";
import huddle from "@/utilities/huddle";

moment.fn.fromNowOrNow = function(a) {
  if (Math.abs(moment().diff(this)) < 25000) {
    // 25 seconds before or after now
    return "just now";
  }
  return this.fromNow(a);
};

export default {
  data: () => ({}),
  computed: {
    items() {
      return _.filter(this.$store.getters.notifications, n => !n.seen);
    }
  },
  methods: {
    ago(time) {
      return moment(time).fromNowOrNow();
    },
    async handleClick(item) {
      // Unseen
      try {
        await this.$http.patch(
          `${this.$store.state.endpoint}notifications/${item.id}`,
          {
            seen: true,
            seenOn: new Date()
          }
        );

        this.$store.dispatch("getNotifications");

        if (item.action == "opennotification") {
          this.$parent.$router.push({
            name: "Notifications"
          });
        }

        if (item.action == "opentimesheet") {
          this.$parent.$router.push({
            name: "Timesheet Edit",
            params: { attendanceId: item.href }
          });
        }

        if (item.action == "close") {
        }
        if (item.action == "starthuddle") {
          huddle.start(
            item.data.url,
            item.data.room,
            this.$store.state.userDetails.firstName,
            this.$store.state.userDetails.email
          );
        }
      } catch (e) {
        console.log(e);

        this.$store.dispatch("getNotifications");
      }

      //Redirect to action
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.v-list__tile__title,
.v-list__tile__sub-title {
  white-space: pre-wrap !important;
  overflow: hidden;
  /* text-overflow: ellipsis;*/
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.theme--light.v-list .v-list__tile__sub-title {
  white-space: pre-wrap !important;
  color: rgba(0, 0, 0, 0.54);
}

.v-list--three-line .v-list__tile__sub-title {
  white-space: initial;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}
</style>
